import React from 'react'
import { ButtonLink } from '@shared/components/button-link'
import { Image } from '@shared/components/image'
import { useSelectDevice } from '@shared/hooks/use-select-device'
import VideoPlay from '@shared/svg/video-play.svg'

import styles from './style.module.scss'

const videos = [
	['https://youtu.be/-Te5tWF2U_U', 'youtube-channel-poster3.png'],
	['https://youtu.be/Y5yfuPPN2hA', 'youtube-channel-poster2.png'],
]

export const View = () => {
	const firstName = useSelectDevice({
		default: videos[0][1],
	})

	const secondName = useSelectDevice({
		default: videos[1][1],
	})

	return (
		<div className={styles.wrapper}>
			{videos.map(([youtubeLink], index) => (
				<ButtonLink
					key={youtubeLink}
					size='s'
					target='_blank'
					rel='noopener noreferrer nofollow'
					href={youtubeLink}
					className={styles.link}
				>
					<Image
						className={styles.image}
						name={index === 0 ? firstName : secondName}
						alt='youtube link'
					/>
					<VideoPlay className={styles.playIcon} />
				</ButtonLink>
			))}
		</div>
	)
}
